/* section-rz.js — recipe pages /blogs/rezepte/<handle>: the „Portionen" stepper in the ingredient list
   (founder feedback 2 Nov 2026; rounding rules from the 2 Nov research brief, deep-dive-1102). Vanilla JS, no deps.

   Markup contract (sections/rz-recipe.liquid, generated from scripts/rezepte/rezepte.json):
   - root [data-rz-por-root data-rz-base data-rz-max data-rz-key data-rz-one data-rz-many]: the ingredient column.
     Inside: [data-rz-por] (the stepper, hidden in the HTML so the page without JS shows the recipe's own amounts),
     [data-rz-step="-1"|"1"] buttons, every [data-rz-n] (the number) and [data-rz-w] (Portion/Portionen).
   - an amount: [data-rz-q (qty) data-rz-u (unit) data-rz-k (kind) data-rz-up (unit plural)] containing [data-rz-amt];
     optional [data-rz-pl data-rz-sg] = the ingredient's plural and singular name; a household measure
     [data-rz-hq data-rz-hu data-rz-hp].
   - the addit row [data-rz-addit data-rz-sp (spoons per portion) data-rz-g (g per portion) data-rz-w1 data-rz-w2]
     with [data-rz-al] (the spoon line) and [data-rz-pp] („… je Portion", shown when more than one portion is listed).
   - [data-rz-snote] in the steps column: „Mengen in der Zubereitung gelten für …", shown while n ≠ the recipe's own.

   Rules: at the recipe's own number every text is the server's (the s8 strings, byte for byte). Otherwise
   g/ml under 10 whole, 10–100 to 5, 100–1000 to 10, from 1000 kg/l with one decimal (decimal comma); EL/TL to ½
   (under 1 EL as TL, from 3 TL as EL, ¼ only below ½ TL); pieces to ½ (at least ½), eggs and cloves whole (at least
   1); only ¼ ½ ¾ as fractions. Prise, Bund and items without an amount never change. Nährwerte, the graphic and
   the JSON-LD stay per portion. The choice is remembered per recipe in localStorage (a convenience: every access in
   try/catch, the page works without it). No animation, so reduced motion needs nothing. */
(function () {
  'use strict';
  if (window.__rzPortions) return;
  window.__rzPortions = true;

  var NB = ' ';
  var FR = ['', '¼', '½', '¾'];
  var UNIT = { g: 1, kg: 1000, ml: 1, l: 1000, TL: 1, EL: 3 };
  var KEEP = /^(prise|prisen|bund|handvoll|msp\.?|messerspitze|schuss|spritzer)$/i;

  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isNaN(n) ? null : n; }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  /* a value on a quarter grid → „1½", „¼", „12" */
  function frac(v) {
    var q = Math.round(v * 4), w = Math.floor(q / 4), f = q % 4;
    return (w || !f ? String(w) : '') + FR[f];
  }
  function half(v, min) { var r = Math.round(v * 2) / 2; return r < min ? min : r; }
  function dec1(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }
  function metricRound(v) {
    if (v < 10) return Math.max(1, Math.round(v));
    if (v < 100) return Math.round(v / 5) * 5;
    if (v < 1000) return Math.round(v / 10) * 10;
    return v;
  }
  /* qty × f in its kind → { v: the rounded number (for plurals), t: the text } */
  function amount(qty, unit, kind, f, unitPl) {
    var v = qty * f, r, tl;
    if (kind === 'mass' || kind === 'volume') {
      v = v * (UNIT[unit] || 1);
      r = metricRound(v);
      if (r >= 1000) return { v: r, t: dec1(r / 1000) + NB + (kind === 'mass' ? 'kg' : 'l') };
      return { v: r, t: r + NB + (kind === 'mass' ? 'g' : 'ml') };
    }
    if (kind === 'spoon') {
      tl = v * (UNIT[unit] || 1);
      if (tl < 0.5) return { v: tl, t: frac(Math.max(0.25, Math.round(tl * 4) / 4)) + NB + 'TL' };
      r = half(tl, 0.5);
      if (r >= 3) return { v: r, t: frac(half(tl / 3, 1)) + NB + 'EL' };
      return { v: r, t: frac(r) + NB + 'TL' };
    }
    r = kind === 'whole' ? Math.max(1, Math.round(v)) : half(v, 0.5);
    return { v: r, t: frac(r) + (unit ? NB + (r > 1 && unitPl ? unitPl : unit) : '') };
  }
  function store(key, n) {
    try {
      if (n == null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, String(n));
    } catch (e) { /* private mode, blocked storage: no memory, the stepper still works */ }
  }
  function recall(key) {
    try { return num(window.localStorage.getItem(key)); } catch (e) { return null; }
  }

  function init(root) {
    if (root.__rzPor) return;
    root.__rzPor = true;
    var base = Math.max(1, Math.round(num(root.getAttribute('data-rz-base')) || 1));
    var max = Math.max(base, Math.round(num(root.getAttribute('data-rz-max')) || 12));
    var one = root.getAttribute('data-rz-one') || 'Portion';
    var many = root.getAttribute('data-rz-many') || 'Portionen';
    var key = 'rz-portions:' + (root.getAttribute('data-rz-key') || location.pathname);
    var ui = root.querySelector('[data-rz-por]');
    if (!ui) return;
    var article = root.closest('.rz') || document;
    var snote = article.querySelector('[data-rz-snote]');
    var less = ui.querySelector('[data-rz-step="-1"]');
    var more = ui.querySelector('[data-rz-step="1"]');
    var out = ui.querySelector('output');

    /* everything that changes keeps its server HTML for the recipe's own number */
    var items = [];
    each(root.querySelectorAll('[data-rz-q]'), function (el) {
      var q = num(el.getAttribute('data-rz-q'));
      var u = el.getAttribute('data-rz-u') || '';
      var k = el.getAttribute('data-rz-k') || 'free';
      var amt = el.querySelector('[data-rz-amt]');
      if (q == null || k === 'free' || KEEP.test(u) || !amt) return;
      items.push({ q: q, u: u, k: k, up: el.getAttribute('data-rz-up') || '', amt: amt, a0: amt.innerHTML, pl: el.querySelector('[data-rz-pl]') });
    });
    each(items, function (it) { if (it.pl) it.pl0 = it.pl.innerHTML; });
    var hhs = [];
    each(root.querySelectorAll('[data-rz-hq]'), function (el) {
      var q = num(el.getAttribute('data-rz-hq'));
      var u = el.getAttribute('data-rz-hu') || '';
      if (q == null || KEEP.test(u)) return;
      var k = u === 'g' || u === 'kg' ? 'mass' : u === 'ml' || u === 'l' ? 'volume' : u === 'EL' || u === 'TL' ? 'spoon' : 'count';
      hhs.push({ el: el, q: q, u: u, k: k, pre: el.getAttribute('data-rz-hp') || '', h0: el.innerHTML });
    });
    var ad = root.querySelector('[data-rz-addit]');
    var adLine = ad && ad.querySelector('[data-rz-al]');
    var adPP = ad && ad.querySelector('[data-rz-pp]');
    var ad0 = adLine ? adLine.innerHTML : '';

    function set(n, remember) {
      n = Math.min(max, Math.max(1, n));
      var f = n / base, own = n === base;
      each(root.querySelectorAll('[data-rz-n]'), function (el) { el.textContent = String(n); });
      each(root.querySelectorAll('[data-rz-w]'), function (el) { el.textContent = n === 1 ? one : many; });
      root.classList.toggle('is-scaled', !own);
      each(items, function (it) {
        if (own) {
          it.amt.innerHTML = it.a0;
          if (it.pl) it.pl.innerHTML = it.pl0;
          return;
        }
        var a = amount(it.q, it.u, it.k, f, it.up);
        it.amt.textContent = a.t;
        if (it.pl) it.pl.textContent = it.pl.getAttribute(a.v > 1 ? 'data-rz-pl' : 'data-rz-sg');
      });
      each(hhs, function (h) {
        if (own) { h.el.innerHTML = h.h0; return; }
        h.el.textContent = '(' + h.pre + amount(h.q, h.u, h.k, f, '').t + ')';
      });
      if (adLine) {
        if (own) adLine.innerHTML = ad0;
        else {
          var sp = (num(ad.getAttribute('data-rz-sp')) || 1) * n;
          var g = (num(ad.getAttribute('data-rz-g')) || 10) * n;
          var spT = frac(Math.round(sp * 4) / 4);
          var w = sp > 1 ? ad.getAttribute('data-rz-w2') : ad.getAttribute('data-rz-w1');
          adLine.textContent = spT + ' ' + w + ' (ca.' + NB + (Math.round(g * 10) / 10 + '').replace('.', ',') + NB + 'g)';
        }
      }
      if (adPP) adPP.hidden = n === 1;
      if (snote) snote.hidden = own;
      less.setAttribute('aria-disabled', n <= 1 ? 'true' : 'false');
      more.setAttribute('aria-disabled', n >= max ? 'true' : 'false');
      root.__rzN = n;
      if (remember) store(key, own ? null : n);
    }

    function step(d) {
      var n = (root.__rzN || base) + d;
      if (n < 1 || n > max) return;
      set(n, true);
    }
    less.addEventListener('click', function () { step(-1); });
    more.addEventListener('click', function () { step(1); });

    var saved = recall(key);
    set(saved && saved >= 1 && saved <= max ? Math.round(saved) : base, false);
    ui.hidden = false;
    /* announce changes from now on, not the restored value at load */
    if (out) out.setAttribute('aria-live', 'polite');
  }

  function boot() { each(document.querySelectorAll('[data-rz-por-root]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) each(e.target.querySelectorAll('[data-rz-por-root]'), init);
  });
})();
